// Engineezy links page: reports every link/icon tap to Google Analytics as a "link_click" event.
// link_text / link_url fill GA4's built-in "Link text" / "Link URL" dimensions, so per-link reports
// work without setting up custom dimensions. GA4 adds the visitor's source (utm_source / referrer) itself.
(function () {
  var root = document.querySelector('[data-ezl]');
  if (!root || (window.Shopify && window.Shopify.designMode)) return; // skip the theme editor

  function track(event) {
    if (event.type === 'auxclick' && event.button !== 1) return; // middle-click only
    var link = event.target.closest('a[data-ezl-title]');
    if (!link || typeof window.gtag !== 'function') return;
    window.gtag('event', 'link_click', {
      link_text: link.getAttribute('data-ezl-title'),
      link_url: link.href,
      link_position: Number(link.getAttribute('data-ezl-position')) || 0,
      link_kind: link.getAttribute('data-ezl-kind'),
      transport_type: 'beacon'
    });
  }

  root.addEventListener('click', track);
  root.addEventListener('auxclick', track);
})();
